import React from 'react'
import { useState } from 'react'
import MyButton from '../../../../UI/form/MyButton'
import MyModal from '../../../../UI/modal/MyModal'
import PrecisionManufacturingIcon from '@mui/icons-material/PrecisionManufacturing';
import AddSeriesInFactoryLineForm from './AddSeriesInFactoryLineForm';

const AddSeriesInFactoryLineFormAdd = ({ packId, box }) => {

    const [open, setOpen] = useState(false)

  return (
     <>
        <MyButton
            onClick={e => setOpen(true)}
        >
            {
                <PrecisionManufacturingIcon />
            }
        </MyButton>

        <MyModal
            open={open}
            setOpen={setOpen}
            header={'Додати товари у виробництво'}
            disableClickOutside={true}
            content={
                <AddSeriesInFactoryLineForm
                    packId={packId}
                    // boxBd={box}
                    setOpen={setOpen}
                />
            }
        />
    </>
  )
}

export default AddSeriesInFactoryLineFormAdd